import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

import { GenericPageableResponse } from '@shared/models/GenericPageableResponse';
import { HttpHandlerService } from '@shared/services/http-handler.service';
import { GenericResponse } from '@shared/models/GenericResponse';
import { Organization } from '@shared/models/Organization';
import { User } from '@shared/models/User';
import { environment } from '@env';

const BASE_URL = `${environment.oauthBaseUrl}/api/v1/users`;

@Injectable({
  providedIn: 'root'
})
export class UserService {

  private loginConfirmed = false;

  constructor(private http: HttpHandlerService) { }

  public fetch(searchCriteria: any): Observable<GenericPageableResponse<User>> {
    return this.http.request<GenericPageableResponse<User>>(BASE_URL)
                    .setParams(searchCriteria)
                    .setErrorMessage('Falha ao obter lista de usuários!')
                    .get();
  }

  public fetchById(id: number): Observable<GenericResponse<User>> {
    const url = `${BASE_URL}/${id}`;
    // return this.http.get<GenericResponse<User>>(url, 'Falha ao obter usuário!');
    return this.http.request<GenericResponse<User>>(url)
                    .setErrorMessage('Falha ao obter usuário!')
                    .get();
  }

  public patch(id: number, data: any): Observable<GenericResponse<User>> {
    const url = `${BASE_URL}/${id}`;
    // return this.http.patch<GenericResponse<User>>(url, data, 'Falha ao atualizar usuário!');
    return this.http.request<GenericResponse<User>>(url)
                    .setBody(data)
                    .setErrorMessage('Falha ao atualizar usuário!')
                    .patch();
  }

  public fetchOrganizations(id: number, searchCriteria: any): Observable<GenericPageableResponse<Organization>> {
    const url = `${BASE_URL}/${id}/organizations`;
    // return this.http.get<GenericPageableResponse<Organization>>([url, searchCriteria], 'Falha ao obter organizações!');
    return this.http.request<GenericPageableResponse<Organization>>(url)
                    .setParams(searchCriteria)
                    .setErrorMessage('Falha ao obter organizações!')
                    .get();
  }

  public appendOrganization(id: number, organization: Organization): Observable<GenericPageableResponse<Organization>> {
    const url = `${BASE_URL}/${id}/organizations`;
    // return this.http.post<GenericPageableResponse<Organization>>(url, organization, 'Falha ao adicionar organização!');
    return this.http.request<GenericPageableResponse<Organization>>(url)
                    .setBody(organization)
                    .setErrorMessage('Falha ao adicionar organização!')
                    .post();
  }

  public removeOrganization(id: number, organizationId: number): Observable<GenericPageableResponse<Organization>> {
    const url = `${BASE_URL}/${id}/organizations/${organizationId}`;
    // return this.http.delete<GenericPageableResponse<Organization>>(url, 'Falha ao remover organização!');githu
    return this.http.request<GenericPageableResponse<Organization>>(url)
                    .setErrorMessage('Falha ao remover organização!')
                    .delete();
  }

  public confirmLogin() {
    if (this.loginConfirmed) {
      return of();
    }
    this.loginConfirmed = true;

    const url = `${BASE_URL}/login`;
    return this.http.post(url, {}, '');
  }

}
